import { useState } from 'react';
import { Wine, Lock } from 'lucide-react';
import { toast } from 'sonner';

const MEMBERS = ['Ayrton', 'Andy', 'Alex', 'Ant', 'Daryl', 'Jack', 'Ryan', 'Leigh'];
const ADMIN_PASSWORD = 'longisland2026'; // You can change this

const MemberSelector = ({ onSelectMember }) => {
  const [selectedMember, setSelectedMember] = useState('');
  const [password, setPassword] = useState('');
  const [showPassword, setShowPassword] = useState(false);

  const isAdmin = selectedMember?.toLowerCase() === 'ayrton';

  const handleMemberChange = (e) => {
    setSelectedMember(e.target.value);
    setPassword('');
    setShowPassword(e.target.value?.toLowerCase() === 'ayrton');
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    if (!selectedMember) return;

    // Check password for admin
    if (isAdmin) {
      if (!password) {
        toast.error('Password required for admin access');
        return;
      }
      if (password !== ADMIN_PASSWORD) {
        toast.error('Incorrect password');
        return;
      }
    }

    onSelectMember(selectedMember);
  };

  return (
    <div className="min-h-screen bg-[#050203] flex items-center justify-center p-6">
      <div className="max-w-md w-full">
        <div className="text-center mb-12">
          <Wine className="w-16 h-16 text-[#E11D48] mx-auto mb-6" />
          <h1 className="font-['Anton'] text-6xl md:text-8xl text-[#F5F5F4] uppercase tracking-tight leading-none mb-4">
            LONG ISLAND
          </h1>
          <p className="text-zinc-400 text-lg uppercase tracking-widest">
            Who's checking in?
          </p>
        </div>

        <form onSubmit={handleSubmit} className="space-y-6">
          <select
            data-testid="member-selector"
            value={selectedMember}
            onChange={handleMemberChange}
            className="w-full bg-zinc-900/50 border-2 border-white/10 text-white text-xl p-4 uppercase tracking-wider focus:border-[#E11D48] focus:outline-none transition-colors"
          >
            <option value="" disabled>
              Select your name...
            </option>
            {MEMBERS.map((member) => (
              <option key={member} value={member}>
                {member}
              </option>
            ))}
          </select>

          {showPassword && (
            <div className="space-y-2 animate-in fade-in duration-300">
              <div className="flex items-center gap-2 text-[#E11D48] text-sm uppercase tracking-widest">
                <Lock className="w-4 h-4" />
                <span>Admin Password Required</span>
              </div>
              <input
                data-testid="admin-password-input"
                type="password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                placeholder="Enter password..."
                className="w-full bg-zinc-900/50 border-2 border-[#E11D48]/30 text-white text-lg p-4 tracking-wider focus:border-[#E11D48] focus:outline-none transition-colors"
              />
            </div>
          )}

          <button
            data-testid="enter-app-button"
            type="submit"
            disabled={!selectedMember || (isAdmin && !password)}
            className="w-full bg-[#E11D48] hover:bg-[#BE123C] text-white font-['Anton'] text-2xl uppercase tracking-widest py-4 transition-colors disabled:opacity-50 disabled:cursor-not-allowed border-2 border-transparent hover:border-white/20"
          >
            Enter
          </button>
        </form>
      </div>
    </div>
  );
};

export default MemberSelector;